import { render, staticRenderFns } from "./ClientReports.vue?vue&type=template&id=671b26f8"
import script from "./ClientReports.vue?vue&type=script&lang=js"
export * from "./ClientReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports